function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  id: "home",
  transform: "translate(-897.000000, -1413.000000)",
  stroke: "#495EEC",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(-1.000000, 1150.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(884.000000, 121.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 109.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-27",
  transform: "translate(0.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.001101,32.75 C20.0912732,28.2103119 17.2108348,25.0232146 16.3597857,23.1887081 C15.0832121,20.4369483 17.4103624,17 20.094033,17 C21.8831467,17 23.518836,17.8780312 25.001101,19.6340937 C26.6386093,17.8780312 28.2479947,17 29.8292571,17 C32.2011507,17 35.0681505,19.8822334 33.5990899,23.1887081 C32.6197162,25.3930245 29.7537199,28.5801218 25.001101,32.75 Z",
  id: "Shape"
})))))));

var SvgIconeCoracao = function SvgIconeCoracao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeCoracao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-coracao.f8d75cbb.svg";
export { ForwardRef as ReactComponent };